export const RoutePostMerchflowCreatePlanogramTemplate = "/merchflow/create-planogram-template";

export interface PayloadPostMerchflowCreatePlanogramTemplate {
  store_pog_id: number;
  category: string;
  subcategory: string;
  template_name: string;
}
